import { createSlice } from "@reduxjs/toolkit";

// Helper functions for loading, success, and failure
const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
};

const suppliersSlice = createSlice({
  name: "suppliers",
  initialState: {
    isLoading: false,

    supplier: {},
    suppliersList: [],  // List of all suppliers
    supplierOrderList: [],  // List of supplier orders
    supplierRating: null,
  },
  reducers: {
    // Get suppliers actions
    getSuppliersRequest: (state) => setLoading(state, true),
    getSuppliersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "suppliersList"),
    getSuppliersFailure: (state) => setFailure(state),

    // Get Supplier Orders actions
    getSupplierDetailsRequest: (state) => setLoading(state, true),
    getSupplierDetailsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "supplierDetails"),
    getSupplierDetailsFailure: (state) => setFailure(state),

    // Get Supplier Orders actions
    getSupplierOrdersRequest: (state) => setLoading(state, true),
    getSupplierOrdersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "supplierOrderList"),
    getSupplierOrdersFailure: (state) => setFailure(state),

    // Delete supplier actions
    deleteSupplierRequest: (state) => setLoading(state, true),
    deleteSupplierSuccess: (state, action) => 
      setSuccessWithData(state, action.payload, "suppliersList"),
    deleteSupplierFailure: (state) => setFailure(state),

    getSupplierRatingRequest: (state) => setLoading(state, true),
    getSupplierRatingSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "supplierRating"),
    getSupplierRatingFailure: (state) => setFailure(state),
  },
});

export const {
  getSuppliersRequest,
  getSuppliersSuccess,
  getSuppliersFailure,
  getSupplierDetailsRequest,
  getSupplierDetailsSuccess,
  getSupplierDetailsFailure,
  getSupplierOrdersRequest,
  getSupplierOrdersSuccess,
  getSupplierOrdersFailure,
  deleteSupplierRequest,
  deleteSupplierSuccess,
  deleteSupplierFailure,
  getSupplierRatingRequest,
  getSupplierRatingSuccess,
  getSupplierRatingFailure,
} = suppliersSlice.actions;

export const supplierReducerSlice = suppliersSlice.reducer;
